import { gql } from "@apollo/client";

export const GET_ALL_FUENTES = gql`
  query allFuenteCapa {
    allFuenteCapa {
        idFuenteCapa
        descripcion
    }
}`;